module.exports = __webpack_public_path__ + "img/Support_Filled_32px_Icon.8d797b94.svg";